import { configureStore } from "@reduxjs/toolkit";
import CommonSlice from "./reducers/Common";
import ToastSlice from "./reducers/Toast";
import UserSlice from "./reducers/Users";
import {
  createStateSyncMiddleware,
  initMessageListener,
} from "redux-state-sync";

const store = configureStore({
  reducer: {
    user: UserSlice,
    common: CommonSlice,
    toast: ToastSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(createStateSyncMiddleware({whitelist:['user/logoutUser']})),
});

initMessageListener(store);
export default store;